import Preloader from '../modules/components/preloader';
import Animation from '../modules/animation/animation';
import Popup from '../modules/components/popup';

import '../../scss/styles.scss';

function entry () {
  const isPopup = document.querySelector('.site-popup[data-popup="popup"]');

  if (isPopup) {
    const popup = new Popup({
      popup: '.site-popup[data-popup=popup]',
      close: '.site-popup-close[data-popup=popup]'
    });
  
    new Preloader('.site-preloader', 2000, () => console.log('Page loaded'))
      .then(() => new Animation('.site-animation', 150))
      .then(() => { setTimeout(() => popup.open(), 1500) });
  } else {
    new Preloader('.site-preloader', 2000, () => console.log('Page loaded'))
      .then(() => new Animation('.site-animation', 150))
  }
}

document.addEventListener('DOMContentLoaded', entry);
